/**
 * CUÁNDO BAJA SOLO EL CHAT (Francisco, 27-09: «al subir en la conversación me manda de nuevo
 * hasta abajo de la nada»).
 *
 * El chat vuelve a pedir los mensajes cada 5 segundos, y cada vez bajaba al final aunque no
 * hubiera nada nuevo: quien subía a leer algo de antes volvía abajo a los 5 segundos. Ahora
 * solo baja al abrir la conversación y cuando llega un mensaje NUEVO, y en ese caso solo si
 * ya estaba abajo o si el mensaje es suyo (acaba de mandarlo). Si está leyendo arriba, se queda.
 */

/** A esta distancia del final (px) se considera que está abajo. */
export const CERCA_DEL_FINAL = 80;

export const estaAbajo = (el) => !el || el.scrollHeight - el.scrollTop - el.clientHeight <= CERCA_DEL_FINAL;

/**
 * @param {object} p
 * @param {boolean} p.primera       primera carga de esta conversación
 * @param {string|null} p.ultimoAntes  id del último mensaje que había
 * @param {string|null} p.ultimoAhora  id del último mensaje que hay ahora
 * @param {boolean} p.estabaAbajo   si estaba abajo antes de que llegara lo nuevo
 * @param {boolean} p.esMio         si el último mensaje lo ha mandado quien mira
 */
export const debeBajar = ({ primera, ultimoAntes, ultimoAhora, estabaAbajo, esMio }) => {
    if (primera) return true;
    if (!ultimoAhora || ultimoAhora === ultimoAntes) return false;
    return Boolean(estabaAbajo || esMio);
};

/** El elemento que de verdad se desplaza (el viewport si es un ScrollArea de Radix). */
export const elementoQueDesplaza = (raiz) =>
    raiz?.querySelector?.('[data-radix-scroll-area-viewport]') || raiz || null;
